export const Types = {
  SET_IS_MOBILE: 'generics/SET_IS_MOBILE',
  SET_IS_LOADING: 'generics/SET_IS_LOADING',
  TOGGLE_CLUB_SMILES_SUBSCRIBE_OPEN: 'generics/TOGGLE_CLUB_SMILES_SUBSCRIBE_OPEN',
  TOGGLE_SHOW_COMPARATOR_PAGE: 'generics/TOGGLE_SHOW_COMPARATOR_PAGE',
  TOGGLE_SHOW_COMPARATOR_BANNER: 'generics/TOGGLE_SHOW_COMPARATOR_BANNER',
  TOGGLE_SHOW_COMPARATOR_SHOWCASE: 'generics/TOGGLE_SHOW_COMPARATOR_SHOWCASE',
  TOGGLE_SHOW_MILES_FIRST: 'generics/TOGGLE_SHOW_MILES_FIRST',
};

export interface IGenericsReduxState {
  isMobile: boolean;
  isLoading: boolean;
  isClubSmilesSubscribeOpen: boolean;
  showComparatorPage: boolean | null;
  showComparatorBanner: boolean | null;
  showComparatorShowcase: boolean | null;
  showMilesFirst: boolean | null;
}

const initialState: IGenericsReduxState = {
  isMobile: false,
  isLoading: false,
  isClubSmilesSubscribeOpen: false,
  showComparatorPage: null,
  showComparatorBanner: null,
  showComparatorShowcase: null,
  showMilesFirst: null,
};

export default function reducer(state = initialState, action: any = {}): IGenericsReduxState {
  switch (action.type) {
    case Types.SET_IS_MOBILE:
      return { ...state, isMobile: action.payload };
    case Types.SET_IS_LOADING:
      return { ...state, isLoading: action.payload };
    case Types.TOGGLE_CLUB_SMILES_SUBSCRIBE_OPEN:
      return { ...state, isClubSmilesSubscribeOpen: !state.isClubSmilesSubscribeOpen };
    case Types.TOGGLE_SHOW_COMPARATOR_PAGE:
      return { ...state, showComparatorPage: action.payload };
    case Types.TOGGLE_SHOW_COMPARATOR_BANNER:
      return { ...state, showComparatorBanner: action.payload };
    case Types.TOGGLE_SHOW_COMPARATOR_SHOWCASE:
      return { ...state, showComparatorShowcase: action.payload };
    case Types.TOGGLE_SHOW_MILES_FIRST:
      return { ...state, showMilesFirst: action.payload };
    default:
      return state;
  }
}

export const setIsMobile = (isMobile: boolean) => ({
  type: Types.SET_IS_MOBILE,
  payload: isMobile,
});

const setIsLoading = (isLoading: boolean) => ({
  type: Types.SET_IS_LOADING,
  payload: isLoading,
});

export const toggleClubSmilesSubscribeOpen = () => ({
  type: Types.TOGGLE_CLUB_SMILES_SUBSCRIBE_OPEN,
});

const toggleShowComparatorPage = (showComparatorPage: boolean) => ({
  type: Types.TOGGLE_SHOW_COMPARATOR_PAGE,
  payload: showComparatorPage,
});

const toggleShowComparatorBanner = (showComparatorBanner: boolean) => ({
  type: Types.TOGGLE_SHOW_COMPARATOR_BANNER,
  payload: showComparatorBanner,
});

const toggleShowComparatorShowcase = (showComparatorShowcase: boolean) => ({
  type: Types.TOGGLE_SHOW_COMPARATOR_SHOWCASE,
  payload: showComparatorShowcase,
});

const toggleShowMilesFirst = (showMilesFirst: boolean) => ({
  type: Types.TOGGLE_SHOW_MILES_FIRST,
  payload: showMilesFirst,
});

export const genericsActions = {
  setIsMobile,
  setIsLoading,
  toggleClubSmilesSubscribeOpen,
  toggleShowComparatorPage,
  toggleShowComparatorBanner,
  toggleShowComparatorShowcase,
  toggleShowMilesFirst,
};
